<template>
	<window-view title="Migrer organisation" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<select-view v-model="org_from" :options="_organisations_from" label="Organisation (kilde)" />
				</grid-view>	
				<grid-view>
					<select-view v-model="org_to" :options="_organisations_to" label="Organisation (destination)" />
				</grid-view>		
				<grid-view v-if="showProgress">
					<div class="progress-bar">
						<div
							class="progress-bar__fill"
							:style="{ width: `${progressPercent}%` }"
						></div>
					</div>
					<div class="progress-bar__label">
						<span class="progress-bar__label-left">{{ progressLabel }}</span>
						<span class="progress-bar__errors">
							({{ errorCount }} fejl)
						</span>
					</div>
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import client from '../../../model/client';

	export default {
		props: ['model'],
		data() {
			return {
				showProgress: false,
				progressMin: 0,
				progressMax: 100,
				progressPos: 0,
				errorCount: 0,
				id: '',
				org_from: null,
				org_to: null,
				organisations_from: [],
				organisations_to: [],
				submit(model) {
					return client.save(model);
				}
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							// Anyhting missing?
							if (!this.org_from || !this.org_to) {
								alert('Udfyld alle felter');
								return false;
							}

							async function migrateDevice(id) {
								try {
									// Check if device ID exists
									try {
										await this.axios.get(`/devices/${id}`);
										this.errorCount += 1;
										return;
									} catch (e) {
										// Nothing
									}

									// Get data for device
									const device = (await this.axios.get(`/migration/devices/${id}`)).data;

									console.log({
										device
									});

									// Create device if not found
									if (await self.submit({
										new_id: device.id,
										organisationId: this.org_to,
										username: device.username,
										password: device.password,
									})) {
										// Save activity
										const batch = [];

										while (device.activity.length > 0) {
											const activity = device.activity.shift();
											const json = JSON.parse(activity.payload);

											batch.push({
												deviceId: id,
												logged: isNaN(Date.parse(json.timestamp)) ? new Date(0).toISOString() : new Date(json.timestamp).toISOString(),
												type: json.call || 'unknown',
												weight: typeof json.weight === 'number' || (typeof json.weight === 'string' && !isNaN(Number(json.weight))) ? Number(json.weight) : 0,
												csq: json.device && (typeof json.device.csq === 'number' || (typeof json.device.csq === 'string' && !isNaN(Number(json.device.csq)))) ? Number(json.device.csq) : 0,
												cops: json.device && typeof json.device.cops === 'string' ? json.device.cops : '',
												temp: typeof json.temp === 'number' || (typeof json.temp === 'string' && !isNaN(Number(json.temp))) ? Number(json.temp) : 0,
												signal: json.radio && (typeof json.radio.signal === 'number' || (typeof json.radio.signal === 'string' && !isNaN(Number(json.radio.signal)))) ? Number(json.radio.signal) : 0,
												ratio: json.radio && (typeof json.radio.ratio === 'number' || (typeof json.radio.ratio === 'string' && !isNaN(Number(json.radio.ratio)))) ? Number(json.radio.ratio) : 0,
												batteryLevel: json.battery && (typeof json.battery.level === 'number' || (typeof json.battery.level === 'string' && !isNaN(Number(json.battery.level)))) ? Number(json.battery.level) : 0,
												batteryVoltage: json.battery && (typeof json.battery.voltage === 'number' || (typeof json.battery.voltage === 'string' && !isNaN(Number(json.battery.voltage)))) ? Number(json.battery.voltage) : 0,
												versionId: '0.0.001',
											});
										}

										await this.axios.post('/data/batch', batch);
									}
								} catch (e) {
									console.error('Fejl ved migrering af enhed', id, e);
									this.errorCount += 1;
								} finally {
									// Update progress
									this.progressPos += 1;
								}
							}

							// Fetch devices to migrate
							const devices = (await this.axios.get(`/migration/organisations/${this.org_from}/devices`)).data;
							
							if (devices.length === 0) {
								alert('Ingen enheder at migrere');
								return false;
							}

							// Setup progress
							this.progressMin = 0;
							this.progressMax = devices.length;
							this.progressPos = 0;
							this.errorCount = 0;

							this.showProgress = true;

							// Migrate devices sequentially
							for (const device of devices) {
								if (device.length === 0) {
									errorCount += 1;
									continue;
								}

								await migrateDevice.call(this, device);
							}

							this.showProgress = false;

							return true;
						}
					}
				];
			},
			_organisations_from() {
				return this.organisations_from.map(val => {
					return {
						label: val.label,
						value: val.id,
					};
				});
			},
			_organisations_to() {
				return this.organisations_to.map(val => {
					return {
						label: val.label,
						value: val.id,
					};
				});
			},
			progressPercent() {
				const total = this.progressMax - this.progressMin;
				if (total <= 0) {
					return 0;
				}
				const clamped = Math.min(
					Math.max(this.progressPos, this.progressMin),
					this.progressMax
				);
				return ((clamped - this.progressMin) / total * 100).toFixed(2);
			},
			progressLabel() {
				return `${this.progressPos} / ${this.progressMax}`;
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};

			this.organisations_from = (await this.axios.get('/migration/organisations')).data;
			this.organisations_to = (await this.axios.get('/organisations?_size=1000')).data.content;
		}
	}
</script>

<style lang="scss" scoped>
	.progress-bar {
		width: 100%;
		height: 10px;
		background-color: #f0f0f0;
		border-radius: 5px;
		overflow: hidden;
		margin-bottom: 5px;

		&__fill {
			height: 100%;
			background-color: #3446e9;
			transition: width 200ms ease-in-out;
		}
	}

	.progress-bar__label {
		font-size: 10px ! important;
		color: #666;
		display: flex;
		justify-content: space-between;
		align-items: center;

		& > * {
			font-size: 12px ! important;
		}
	}

	.progress-bar__errors {
		color: #c62828;
	}
</style>
